export default __webpack_public_path__ + "static/media/good-point.b24c3d77.gif";